// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33fNn","comment":"styles_comment__2x3ea"};